//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useState, useEffect, useContext } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Autocomplete,
  IconButton,
  TextField,
} from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

// === COMPONENTS ===
import { Spacer            } from 'components/Spacer';
import { ExpressionContext } from 'pages/DocAnalytics/RuleView/components/ExpressionContext/ExpressionContext';
import { DataTypeSelect    } from '../DataTypeSelect/DataTypeSelect';
import { DocumentSelect    } from '../DocumentSelect/DocumentSelect';

// === UTILS ===
import { keyframes } from 'components/utils';

//#endregion

//-----------------------------------------------------------------
export function FieldControls( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { id, data, is_predicate } = props;

  const { updateExpression, updatePredicate, fields } = useContext( ExpressionContext );

  const [ field_name, setFieldName ] = useState( data?.name );
  const [ is_open   , setIsOpen    ] = useState( false );
  const [ is_confirm, setIsConfirm ] = useState( false );
  const [ is_reject , setIsReject  ] = useState( false );

  const expand_icon = is_open ? <ExpandLess /> : <ExpandMore />;

  const keyframe_change = is_confirm ? keyframes.confirm : is_reject ? keyframes.reject : undefined;

  //#endregion

  //#region [STYLES]

  const theme = useTheme();
  const _styles = {
    container: {
      gridColumn: 3,
      gridRow: 1,
      // -----
      display: 'grid',
      width:'100%',
      columnGap:'0.5rem',
      gridTemplateColumns:'auto 1fr auto',
      gridTemplateRows:'1fr'
    },
    select_field: {
      width: '100%',
      maxWidth: '40rem',
      animation: keyframe_change ? `${keyframe_change} 1s 1` : '',
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
    },
    button_add: {
      backgroundColor: theme.palette.primary[theme.palette.mode],
      color: 'white'
    },
    button_expand: {
      width  : '3rem',
      height : '3rem',
    },
  }

  const SELECT_FIELD = {
    sx          : _styles.select_field,
    id          : 'field-select',
    options     : fields,
    value       : field_name,
    size        : 'small',
    freeSolo    : true, 
    onChange    : onChange,
    renderInput : (params) => <TextField {...params} label="Field" />,
    name        : 'da_predicate_field_select',
    disableClearable : true,
  };

  const BUTTON_EXPAND = {
    sx: _styles.button_expand,
    children: [expand_icon],
    onClick: () => { setIsOpen(!is_open) }
  };
    
  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    if( !is_confirm ) return;

    let interval_change = setInterval(() => {
      setIsConfirm(false);
    }, 500);

    return ()=>{
      clearInterval( interval_change );
    }
  }, [is_confirm] );

  useEffect( () => {
    if( !is_reject ) return;

    let interval_change = setInterval(() => {
      setIsReject(false);
    }, 500);

    return ()=>{
      clearInterval( interval_change );
    }
  }, [is_reject] );

  //#endregion

  //#region [EVENTS]
  
  //-----------------------------------------------------------------
  function onChange( event, value ) {
    //-----------------------------------------------------------------
    if( !value?.value ) {
      setIsReject( true );
      return;
    }
    const update = is_predicate ? updatePredicate : updateExpression;
    update( id , { name: value.value } )
    setIsConfirm( true );
  }
  
  //-----------------------------------------------------------------
  function onChange_Document( value ) {
    //-----------------------------------------------------------------
    const update = is_predicate ? updatePredicate : updateExpression;
    update( id , { numcode: value.numcode } )
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <div style={_styles.container}>
        <DataTypeSelect id={id} type={data?.type} />
        <div>
          <Autocomplete { ...SELECT_FIELD } />
          <div style={{ display: is_open ? '' : 'none' }}>
            <Spacer />
            <DocumentSelect onChange={onChange_Document} numcode={data?.numcode} />
          </div>
        </div>
        <IconButton { ...BUTTON_EXPAND } />
      </div>
    );
  }

  //#endregion

  return display();
}
